import React from "react";

interface ErrorMessage {
  msg?: string;
  errorClassName?: string;
}

const defaultErrorMessage: ErrorMessage = {
  msg: "Ole hyvä, ja ota yhteyttä henkilökuntaan.",
  errorClassName: "",
};

const ErrorContainer: React.FC<ErrorMessage> = (props) => {
  return (
    <div className="dqm-tcui-error_container dqm-tcui-overlay dqm-tcui-fullpanel">
      <h1 className="dqm-tcui-error_container__title">
        Vuoronumeroautomaatissa
        <br /> on tilapäinen häiriö.
      </h1>
      <div className="dqm-tcui-error_container__text">
        <p className="dqm-tcui-error_container-text__message">{props.msg}</p>

        {props.errorClassName !== "" ? (
          <p
            className={
              "dqm-tcui-error_container-text__error-icon " +
              props.errorClassName
            }
          ></p>
        ) : null}
      </div>
    </div>
  );
};

ErrorContainer.defaultProps = defaultErrorMessage;

export default ErrorContainer;
